var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkipAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1H3.5C2.94772 1 2.5 1.44772 2.5 2V38C2.5 38.5523 2.94772 39 3.5 39H30.5C31.0523 39 31.5 38.5523 31.5 38V12M20.5 1L31.5 12M20.5 1V11C20.5 11.5523 20.9477 12 21.5 12H31.5",
    stroke: "#DEDCE5",
    strokeWidth: 1.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.2941,
    cy: 36.7058,
    r: 11.2941,
    transform: "rotate(-45 36.2941 36.7058)",
    fill: "#DEDCE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0826 33.5081L38.0073 36.5835L41.2048 39.781L39.3854 41.6004L36.1879 38.4029L33.0965 41.4943L31.49 39.8878L34.5814 36.7964L31.3993 33.6143L33.2187 31.7949L36.4008 34.977L39.4761 31.9016L41.0826 33.5081Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipAttachment);
export default __webpack_public_path__ + "static/media/skip-attachment.86a43aeb.svg";
export { ForwardRef as ReactComponent };